import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class IssueLineQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  guid_parent?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  txn_src_channel?: Optional<string> = Optional.empty();
}

export class IssueLineCriteriaModelQuery {
  query = '';

  constructor(issueLineCriteriaModel: IssueLineQueryCriteriaClass) {

    if (!issueLineCriteriaModel) {
      return;
    }

    this.query += issueLineCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += issueLineCriteriaModel.guid_parent.filter(x => x !== '').map(x => '&guid_parent=' + x).orElse('');
    this.query += issueLineCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += issueLineCriteriaModel.txn_src_channel.filter(x => x !== '').map(x => '&txn_src_channel=' + x).orElse('');

    this.query += '&status=' + issueLineCriteriaModel.status;
    this.query += '&orderBy=' + issueLineCriteriaModel.orderBy;
    this.query += '&order=' + issueLineCriteriaModel.order;
    this.query += '&offset=' + issueLineCriteriaModel.offset + '&limit=' + issueLineCriteriaModel.limit;
  }
}
